export default function Add() {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
            <path
                className="bg"
                d="M20 10C20 4.47715 15.5228 0 10 0C4.47715 0 0 4.47715 0 10C0 15.5228 4.47715 20 10 20C15.5228 20 20 15.5228 20 10Z"
                fill="#3F68E0"
            />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M5.69721 10.6972H9.30279V14.3028C9.30279 14.5061 9.36815 14.6732 9.49888 14.8039C9.62961 14.9346 9.79665 15 10 15C10.2034 15 10.3704 14.9346 10.5011 14.8039C10.6318 14.6732 10.6972 14.5061 10.6972 14.3028V10.6972H14.3028C14.5061 10.6972 14.6732 10.6318 14.8039 10.5011C14.9346 10.3704 15 10.2034 15 10C15 9.79665 14.9346 9.62961 14.8039 9.49888C14.6732 9.36815 14.5061 9.30279 14.3028 9.30279H10.6972V5.69721C10.6972 5.49386 10.6318 5.32682 10.5011 5.19609C10.3704 5.06536 10.2034 5 10 5C9.79665 5 9.62961 5.06536 9.49888 5.19609C9.36815 5.32682 9.30279 5.49386 9.30279 5.69721V9.30279H5.69721C5.49386 9.30279 5.32682 9.36815 5.19609 9.49888C5.06536 9.62961 5 9.79665 5 10C5 10.2034 5.06536 10.3704 5.19609 10.5011C5.32682 10.6318 5.49386 10.6972 5.69721 10.6972Z"
                fill="white"
            />
        </svg>
    );
}
